<template>
    <div>
        <header>
            <a :href="lpUrl" target="blank" title="Ir para site principal">
                <i class="ico-iouu logotipo" aria-hidden="true"></i>
            </a>
            <div class="d-flex align-items-center cta">
                <span>
                    <small>Retorno potencial no ano <i class="far fa-question-circle" data-toggle="tooltip" title="Considerando o retorno médio dos empréstimos em curso (CDI) até o mês de abril/2018."></i></small>
                    <strong>{{cdi}} do CDI</strong>
                </span>
                <a href="#cta" class="btn btn-primary">Comece a investir</a>
            </div>
        </header>
        <main>
            <router-view  />
        </main>
        <footer>
            <div class="container">
                <div class="row menu-footer">
                    <div class="col-12 col-md-9">
                        <nav class="nav">
                            <a class="nav-link" :href="lpUrl" title="Ir para o site">Ir para o site</a>
                            <a class="nav-link" :href="lpUrl+'/quem-somos/'" title="Quem somos">Quem somos</a>
                            <a class="nav-link" :href="lpUrl+'/emprestimos/'" title="Empréstimos">Empréstimos</a>
                            <a class="nav-link" :href="lpUrl" title="Investimentos">Investimentos</a>
                            <a class="nav-link" href="https://blog.iouu.com.br" title="Blog">Blog</a>
                            <a class="nav-link" :href="lpUrl+'/termos-e-condicoes/'" title="Temos e condições">Temos e condições</a>
                            <a class="nav-link" :href="lpUrl+'/politica-de-privacidade/'" title="Política de privacidade">Política de privacidade</a>
                        </nav>
                    </div>
                    <div class="col-12 col-md-3 text-center text-md-right">
                        <div class="footer__social">
                            <a class="fa-stack fa-1x" href="https://www.facebook.com/IouuBrasil/" target="_blank" title="Facebook">
                                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                                <i class="fab fa-facebook-f fa-stack-1x"></i>
                            </a>
                            <a class="fa-stack fa-1x" href="https://twitter.com/iouubrasil" target="_blank" title="Twitter">
                                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i>
                            </a>
                            <a class="fa-stack fa-1x" href="https://www.linkedin.com/company/iouu" target="_blank" title="Linkedin">
                                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                                <i class="fab fa-linkedin-in fa-stack-1x"></i>
                            </a>
                            <a class="fa-stack fa-1x" href="https://vimeo.com/iouubrasil" target="_blank" title="Instagram">
                                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i>
                            </a>
                            <a class="fa-stack fa-1x" href="https://www.instagram.com/iouubrasil/" target="_blank" title="Vimeo">
                                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                                <i class="fab fa-vimeo-v fa-stack-1x"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <hr class="divider">
                <div class="row">
                    <div class="col-12 text-center">
                        <i class="ico-iouu logotipo" aria-hidden="true"></i>
                        <p>© 2019 - IOUU TODOS OS DIREITOS RESERVADOS.</p>
                        <small>IOUU.com.br pertence à IOUU Tecnologia e Serviços Financeiros - Epp (“IOUU”).</small>
                        <small>A IOUU não é uma instituição financeira e não realiza operações de financiamento, investimentos ou quaisquer outras operações privativas de instituições financeiras.</small>
                        <small>A IOUU é uma plataforma digital que atua como correspondente bancário para facilitar o processo de contratação de empréstimos.</small>
                        <small>Como correspondente bancário, seguimos as diretrizes do Banco Central do Brasil, nos termos da Resolução nº. 3.954, de 24 de fevereiro de 2011.</small>
                        <small>Somos correspondentes bancários das seguintes instituições: Parati Crédito, Financiamento e Investimento S/A (Ouvidoria da Instituição Financeira: 0800 723 4787) e Money Plus SCMEPP LTDA (“BMP Money Plus”) (Ouvidoria da Instituição Financeira: 0800 601 52 89).</small>
                        <small>IOUU Tecnologia e Serviços Financeiros Ltda - Epp. é uma sociedade limitada registrada sob o CNPJ/MF 26.484.548/0001-48, com sede na Av. Paulista, 807, 23º andar, Conjunto: 2315 - Bela Vista, São Paulo - SP, 01310-300.</small>
                        <small>Os correspondentes bancários são empresas contratadas por instituições financeiras e demais instituições autorizadas pelo Banco Central do Brasil para a prestação de serviços de atendimento aos clientes e usuários dessas instituições. Entre os correspondentes mais conhecidos encontram-se as lotéricas e o banco postal.</small>
                        <small>Informações adicionais - Custo Efetivo Total: CET mínimo de 1,3% ao mês e máximo de 7,5% ao mês. Exemplo - Empréstimo de R$ 100.000,00 para pagar em 2 anos (24 meses) – Total de 24 parcelas de R$ 5.349,40. Valor total a pagar igual a R$ 128.385,60 com uma taxa de juros de 1,81% ao mês (24,01% ao ano). CET de 2,1% ao mês (28,27% ao ano).</small>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Modais -->
        <div class="modal fade" id="id-001" tabindex="-1" role="dialog" aria-labelledby="id-001" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-001">Quais serviços a IOUU oferece para os investidores?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>A IOUU fornece uma plataforma que conecta os investidores (pessoa física e jurídica) a Micro, Pequenas e Médias empresas, além de micro e nano empreendedores de baixa renda, utilizando tecnologias inovadoras para analisar as
                            solicitações de empréstimo de forma rápida, online, sem burocracias e com baixa taxa de juros. Dessa forma, criamos uma oportunidade para investidores decidirem para quem e quando querem emprestar e em trocar receber
                            rentabilidades justas.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="id-002" tabindex="-1" role="dialog" aria-labelledby="id-002" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-002">Qual o valor mínimo de investimento?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Os limites de investimento variam conforme a modalidade escolhida:</p>
                        <ul>
                            <li>Investimento Coletivo: a partir de <strong>R$ 2.000,00</strong>;</li>
                            <li>Investimento de Impacto: a partir de <strong>R$ 500,00</strong>;</li>
                            <li>Investimento Social: a partir de <strong>R$ 100,00</strong>.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="id-003" tabindex="-1" role="dialog" aria-labelledby="id-003" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-003">Quanto custa investir na IOUU?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Não existe custo algum para investir na oportunidades oferecidas pela plataforma da IOUU.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="id-004" tabindex="-1" role="dialog" aria-labelledby="id-004" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-004">Qual o procedimento em caso de atraso da parcela mensal?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Para transmitir mais segurança aos investidores e estabelecer um processo transparente com os tomadores de empréstimo, a IOUU tem um processo para tratar as situações de inadimplência. Confira como ele funciona <a href="http://bit.ly/2PYsEn8" target="_blank">acessando este link</a>.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="id-005" tabindex="-1" role="dialog" aria-labelledby="id-005" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-005">Qual a garantia que receberei meu investimento de volta?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Assim como em qualquer investimento, não existe garantia de retorno e as taxas de rendimento são anunciadas com base na premissa de que os empréstimos sejam pagos em dia pelos Tomadores, havendo risco de o retorno ser inferior ao projetado ou até mesmo de não haver retorno, em caso de inadimplemento pelo Tomador. O que fazemos aqui na IOUU é mitigarmos esse risco de inadimplência ao máximos com técnicas inovadoras de análise preditiva e de crédito.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="id-006" tabindex="-1" role="dialog" aria-labelledby="id-006" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="id-006">A IOUU é um banco ou instituição financeira?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Não, a IOUU atua como correspondente bancário que utliza as mais modernas tecnologias para conectar empreendedores e investidores, garantindo assim, um melhor negócio para todos.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../assets/styles/landing-page/vars";
    @import "../../assets/styles/landing-page/mixins";

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 80px;
        padding-left: 60px;
        padding-right: 60px;
        border-bottom: 1px solid #ddd;
        position: fixed;
        background: #fff;
        z-index: 100;

        a {
            color: $tealish;
            text-decoration: none;

            &:hover {
                color: darken($tealish, 7%);
                text-decoration: none;
            }
        }

        i {
            &.logotipo {
                @include font-size(80px);
                @include line-height(80px);
            }
        }

        span {
            @include font-size(15px);
            @include line-height(15px);
            padding-right: 15px;
            display: flex;
            align-items: center;
            color: #999;

            strong {
                @include font-size(18px);
                @include line-height(18px);
                padding-left: 10px;
                color: #666;
            }
        }

        @include mobile {
            position: absolute;
            background: none;
            border-bottom: none;
            padding-left: 30px;
            padding-top: 30px;

            .cta {
                display: none!important;
            }
        }
    }

    main {
        padding-top: 80px;
        padding-left:0px;
        padding-right: 0px;
        padding-bottom: 0px;

        @include xs {
            padding-top: 0px;
        }

        @include sm {
            padding-top: 0px;
        }
    }

    .btn {
        font-weight: bold;

        &-primary {
            color: #fff;
            border-color: $tealish;
            background: $tealish;

            &:hover {
                color: #fff;
                border-color: darken($tealish, 7%);
                background: darken($tealish, 7%);
            }

            &:focus {
                color: #fff;
                box-shadow: 0 0 0 0.2rem rgba($tealish, .5);
            }

            &:not(:disabled) {
                &:not(.disabled) {
                    &:active {
                        border-color: darken($tealish, 7%);
                        background: darken($tealish, 7%);

                        &:focus {
                            box-shadow: 0 0 0 0.2rem rgba($tealish, .4);
                        }
                    }
                }
            }
        }
    }

    footer {
        border-top: 1px solid #ddd;
        color: #999;
        padding-top: 20px;
        padding-bottom: 40px;

        hr {
            margin-top: 15px!important;
        }

        .menu-footer {
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .nav {
            &-link {
                color: #999;
                padding-left: 0px;
                @include font-size(13px);

                &:last-child {
                    padding-right: 0px;
                }
            }
        }

        .logotipo {
            @include font-size(70px);
        }

        p {
            @include font-size(11px);
            font-weight: bold;
            color: #999;
        }

        small {
            display: block;
            @include font-size(11px);
            padding-bottom: 10px;

            &:last-child {
                padding-bottom: 0px;
            }
        }

        .footer {

            &__social {
                a {
                    display: inline-block;
                    margin: 0 0 0 2px;
                    color:#fff;
                    font-weight: normal;
                    @include font-size(15px);
                    @include transition(all 600ms);


                    i.fa-inverse {
                        color:#999999;
                    }

                    &:hover {
                        @include transition(all 600ms);
                        color:#fff;

                        i.fa-inverse {
                            color:#bbb;
                        }
                    }
                }
            }
        }

        // MOBILE
        @include xs {
            margin: 0 15px 15px 15px;
            padding-top: 0px;
            padding-bottom: 10px;

            nav {
                justify-content: center;
                padding-bottom: 15px;
            }
        }

        @include sm {
            margin: 0 15px 15px 15px;
            padding-top: 0px;
            padding-bottom: 10px;

            nav {
                justify-content: center;
                padding-bottom: 15px;
            }
        }
    }

    // modal
    .modal {
        &-backdrop.show {
            opacity: 0.9;
        }

        &-content {
            padding: 10px;
        }

        &-header {
            border-bottom: none;
            padding-left:25px;
            padding-right: 25px;

            h5 {
                @include font-size(22px);
                font-weight: 700;
                @include separador(220px, 5px, 20px, 5px, 0, auto, $tealish);

                i {
                    color: #999;
                    @include font-size(40px);
                    padding-right: 10px;
                }
            }
        }

        &-body {
            padding:0 25px;
        }
    }
</style>

<script>
    export default {
        metaInfo: {
            htmlAttrs: {
                lang: 'pt-br'
            },
            link: [
                { rel: 'stylesheet', href: 'https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css' },
                { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css' },
            ],
            script: [
                { src: '/static/assets/js/bootstrap-password-toggler.min.js'},
                { src: '/static/assets/js/landingpage.js'},
            ]
        },
        data() {
            return {
                lpUrl:process.env.LP_URL,
                "cdi": "384,07%"
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/layouts/LandingPage.vue